// // Receipt.js
// import React from "react";
// import ClassPrinter from "./ClassPrinter"; // Import the ClassPrinter

// const Receipt = ({ data }) => {
//   const getReceiptText = () => {
//     return `
//     Terraweb.africa                 
//     --------------------------------------------------------------------
//     Company: ${data.company}
//     --------------------------------------------------------------------
//     reciept ID: ${data.farmerid}
//     username: ${data.username}
//     phone number:${data.phone}
//     weight:${data.weight}
//     ---------------------------------------------------------------------
//     Total: ${data.weight}
//     ---------------------------------------------------------------------
//     Thank you for choosing Our Company, We Value You.



    
//   `;
//   };
//   const handlePrint = () => {
//     const receiptText = getReceiptText(); // Implement this function to get the receipt text

//     // Create an instance of ClassPrinter
//     const printer = new ClassPrinter();

//     // Call the print method to print the receipt
//     printer.print(receiptText);
//   };

//   return (
//     <div
//       className="bg-white br4 shadow-3 w-100  pa5
// "
//     >
//       <h1 className="">Print from here</h1>
//       <button
//         className="br-pill pa2 bg-green bw0 white b f3"
//         onClick={handlePrint}
//       >
//         Print Receipt
//       </button>
//     </div>
//   );
// };

// export default Receipt;

//receipt from AI
// Receipt.js
import React from "react";
import ClassPrinter from "./ClassPrinter";

const Receipt = ({ data, user }) => {
  const getReceiptText = () => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-KE", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const formattedTime = now.toLocaleTimeString("en-KE");

    const printedBy = user?.name || "Admin";

    return `
    Terraweb.africa                 
    --------------------------------------------------------------------
    Printed On: ${formattedDate} at ${formattedTime}
    Printed By: ${printedBy}
    --------------------------------------------------------------------
    Company: ${data.company}
    --------------------------------------------------------------------
    Receipt ID: ${data.farmerid}
    Username: ${data.username}
    Phone Number: ${data.phone}
    Weight: ${data.weight}
    ---------------------------------------------------------------------
    Total: ${data.weight}
    ---------------------------------------------------------------------
    Thank you for choosing Our Company.
    We Value You.
    `;
  };

  const handlePrint = () => {
    const receiptText = getReceiptText();
    const printer = new ClassPrinter();
    printer.print(receiptText);
  };

  return (
    <div className="bg-white br4 shadow-3 w-100 pa5">
      <h1 className="">Print from here</h1>
      <button
        className="br-pill pa2 bg-green bw0 white b f3"
        onClick={handlePrint}
      >
        Print Receipt
      </button>
    </div>
  );
};

export default Receipt;
